import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Drawer } from "../../components/Drawer";
import { MenuTree } from "../../components/MenuTree";
import { getDefaultLang, langs, tryNow } from "../../utils";
import "./styles.less";

export const MobileHeader = (props) => {
  const { y, mode, menu, user } = props;

  let { i18n } = useTranslation();
  // 控制菜单是否打开的状态
  const [menuOpen, setMenuOpen] = useState(false);
  //
  const [visible, setVisible] = useState(false);
  const defaultLang = getDefaultLang();
  const [lang] = useState(defaultLang);
  //
  const isWindow = () => typeof window !== "undefined";
  const change = (event) => {
    const _lang = event.target.value;
    i18n.changeLanguage(_lang);
    setCookieLang(_lang);
    window.location.reload();
  };
  const setCookieLang = (lang) => {
    const topLevelDomain = window.location.hostname
      .split(".")
      .slice(-2)
      .join(".");
    document.cookie = `_authing_lang=${lang}; path=/; domain=${topLevelDomain}`;
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
    setCookieLang(lang);
  }, [i18n, lang]);

  useEffect(() => {
    if (document && window) {
      const _html = document.getElementsByTagName("html")[0];
      const _body = document.body;
      // const currentFontSize = window
      //   .getComputedStyle(_html, null)
      //   .getPropertyValue("font-size");
      // _html.setAttribute("style", `font-size: ${currentFontSize};`);
      if (isWindow()) {
        _html.style.overflow = "unset";
      }

      _body.removeAttribute("style");
    }
  }, []);

  const clickPersonal = useCallback(() => {
    if (user) {
      window.location.href = "https://console.authing.cn/u";
    } else {
      tryNow();
    }
  }, [user]);
  return (
    <>
      <div className="mobile-header authing-mobile-header-display">
        <Link className="header-logo" to="/">
          <img
            src={"//files.authing.co/authing-website/authing-logo-0830.png"}
            alt=""
          />
        </Link>
        <div className="header-action">
          <div className="header-action-item" onClick={clickPersonal}>
            <i className="icon authing-icon authing-account-pin-circle-line"></i>
          </div>
          <div className="header-action-item" style={{ position: "relative" }}>
            <i
              className="icon authing-icon authing-customer-service-2-linebeifen"
              onClick={() => {
                // setVisible(true);
                window.open("https://www.authing.cn/authingform");
              }}
            ></i>
            {/* <ConsultFormModal {...{ visible, setVisible }} /> */}
          </div>
          <div className="header-action-item" style={{ position: "relative" }}>
            <i className="icon authing-icon authing-language"></i>
            <select
              name="lang"
              onChange={change}
              value={lang}
              style={{ position: "absolute", left: 0, width: 34, opacity: "0" }}
            >
              {langs.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <div className="header-action-item">
            <div
              onClick={() => {
                setMenuOpen((state) => {
                  if (state) {
                    // close
                    const _html = document.getElementsByTagName("html")[0];
                    const _body = document.body;
                    const currentFontSize = window
                      .getComputedStyle(_html, null)
                      .getPropertyValue("font-size");
                    _html.setAttribute(
                      "style",
                      `font-size: ${currentFontSize};`
                    );
                    _body.removeAttribute("style");
                  } else {
                    // open
                    const _html = document.getElementsByTagName("html")[0];
                    const _body = document.body;
                    const currentFontSize = window
                      .getComputedStyle(_html, null)
                      .getPropertyValue("font-size");
                    _html.setAttribute(
                      "style",
                      `font-size: ${currentFontSize};overflow:hidden`
                    );
                    _body.style = "overflow:hidden";
                  }

                  return !state;
                });
              }}
            >
              {menuOpen ? (
                <i className="icon authing-icon authing-close-line"></i>
              ) : (
                <i className="icon authing-icon authing-menu-fill"></i>
              )}
            </div>
          </div>
        </div>
      </div>
      <Drawer
        visible={menuOpen}
        onClose={() => {
          setMenuOpen(false);
        }}
      >
        <MenuTree dataSource={menu} user={user} />
      </Drawer>
    </>
  );
};
